export default {"src":"/_next/static/media/illustration-biscuits.bbf27432.svg","height":92,"width":120};